import { RunKind } from '../models/test-run.model';

/** Ein Weg im Router: die Befehle des Pfads und die Parameter, die daran haengen. */
export interface TestRunLink {
  commands: string[];
  queryParams: { art: RunKind };
}

/**
 * Der Weg auf die Durchlaeufe-Zwischenebene eines Laufs (NEX-1037).
 *
 * <p>An einer Stelle, weil zwei Sichten dorthin fuehren: die Testlauf-Uebersicht und die
 * Pipeline-Karte des Live-Dashboards. Der Pfad allein reichte dabei nicht — die Ebene liest die
 * Art des Laufs aus dem Query-Parameter, weil das Lauf-Detail sie nicht herausgibt. Wer den
 * Parameter vergisst, landet auf einer Seite, die den Lauf fuer manuell haelt.
 */
export function testRunExecutionsLink(projectId: string, runId: string, art: RunKind): TestRunLink {
  return {
    commands: ['/projects', projectId, 'test-runs', runId, 'executions'],
    queryParams: { art },
  };
}
